module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00585.836faa0c.jpg";